module.exports = __webpack_public_path__ + "static/warlight-492452d932b9200248125d8da3e472f2.jpg";